<template>
  <div id="AdminHeaderDiv" class="container admin-div" v-if="showAdminHeader()">
    <sdx-loading-spinner id="spinner-adminHeaderDivContent" size="large" sr-hint="Loading. Please wait."
                         style="display: none"></sdx-loading-spinner>
    <div id="adminHeaderDivContent" class="row">
      <span class="label col-sm-10 sdx-light-theme admin-select-text">Admin Mode: Select another user:</span>
      <sdx-select id="adminViewUserEmail"
                  class="col-sm-10"
                  placeholder="Yourself"
                  keyboard-behavior="filter"
                  filter-min-length="2"
                  @input="viewUserEmailChanged"
                  v-model="viewUserEmail"
      >
        <sdx-select-option
            class="adminSelectOption"
            v-for="viewUser in viewUserList"
            :test-dataId="viewUser.apigeeOwnerEmail"
            :key="viewUser.apigeeOwnerEmail"
            :value="viewUser.apigeeOwnerEmail"
            :selected="isSelectedViewUserEmail(viewUser.apigeeOwnerEmail)"
        >
          {{    viewUser.firstName + ' ' + viewUser.lastName + ' (' + viewUser.email + (viewUser.email != viewUser.apigeeOwnerEmail ? ' / ' + viewUser.apigeeOwnerEmail : '') + ')' }}
        </sdx-select-option>
      </sdx-select>
      <sdx-dialog
          v-bind:id="'add-modal'"
          label="Add another user's email"
          class="clearfix"
      >
        <sdx-dialog-toggle>
          <sdx-button
              class="col-sm-auto "
              id="addButton"
              title="Add another email, which is not in the list. Mostly users only with DM Rights, but without an Apigee account."
              label="Add"
          />
        </sdx-dialog-toggle>
        <sdx-dialog-content style="max-width: 688px">
          <div class="row">
            <div class="col margin-bottom-2">
              <sdx-input
                  id="newEmail"
                  name="Email"
                  label="Email"
                  class="sdx-input"
                  type="email"
                  placeholder=""
                  :value="newEmail"
                  @input="newEmail=$event.target.value"
              >
              </sdx-input>
              <sdx-validation-message v-if="!validateEmail(newEmail)" validation-message="Please enter a valid email address!"></sdx-validation-message>
            </div>
          </div>

          <sdx-button-group layout="responsive-fill">
            <sdx-button
                id="cancelButton"
                label="Cancel"
                @click="closeModal('add-modal')"
                theme="secondary"
            ></sdx-button>
            <sdx-button
                id="addButtonModal"
                label="Add"
                :disabled="!validateEmail(newEmail)"
                @click="addAnotherViewUser()"
            ></sdx-button>
          </sdx-button-group>
        </sdx-dialog-content>
      </sdx-dialog>
    </div>
  </div>
</template>

<script>
import adminService from '@/services/admin.service';
import userService from '@/services/user.service';
import loadingSpinnerService from "@/services/loading-spinner.service";
import {logger} from "@/services/logger.service";
import {validateEmail} from "@/util/utility";

const EVENT_ADMIN_VIEW_EMAIL_CHANGED = "view-email-changed";
// Include the new overall statistics route so admin user-switching remains available there.
const ROUTES_WITH_ADMIN_HEADER = [
  '/statistics',
  '/statistics/overall',
  '/statistics/costlimit',
  '/statistics/country',
  '/outbox',
  '/outbox/email',
  '/inbox',
  '/sendsms',
  '/campaigns',
  '/campaigns/create',
  '/campaigns/edit',
  '/campaigns/summary',
  '/prefix/allowlist',
  '/cost/limit',
  '/subscription/details',
  '/billing/profiles/view/user'
];
// Same route list for admins without FMG rights.
const ROUTES_WITH_ADMIN_WITHOUT_FMG_HEADER = [
  '/statistics',
  '/statistics/overall',
  '/statistics/costlimit',
  '/statistics/country',
  '/prefix/allowlist',
  '/cost/limit',
  '/subscription/details',
  '/billing/profiles/view/user'
];

export default {
  props: [],
  emits: [EVENT_ADMIN_VIEW_EMAIL_CHANGED],
  data() {
    return {
      isAdmin: false,
      isAtLeastAdminWithoutFmg: false,
      newEmail: '',
      viewUserEmail: "",
      viewUserList: [],
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    validateEmail,
    showAdminHeader() {
      return (this.isAdmin && ROUTES_WITH_ADMIN_HEADER.includes(this.$route.path))
          || (this.isAtLeastAdminWithoutFmg && ROUTES_WITH_ADMIN_WITHOUT_FMG_HEADER.includes(this.$route.path));
    },
    async loadData() {
      this.isAdmin = await userService.isAdmin();
      this.isAtLeastAdminWithoutFmg = await userService.isAtLeastAdminWithoutFmg();
      if (this.isAdmin) {
        await this.loadViewUserEmailList();
      }
    },
    async loadViewUserEmailList() {
      loadingSpinnerService.show("adminHeaderDivContent")
      this.viewUserList = await adminService.getCustomers();
      this.viewUserEmail = await userService.getViewUserEmail();
      loadingSpinnerService.hide("adminHeaderDivContent")
    },
    viewUserEmailChanged() {
      this.changeViewUserEmail(arguments[0].target.value);
    },
    changeViewUserEmail(email) {
      this.viewUserEmail = email;
      userService.setViewUserEmail(this.viewUserEmail);
      this.notifyDevAppChanged();
    },
    notifyDevAppChanged() {
      logger.debug("EVENT: " + EVENT_ADMIN_VIEW_EMAIL_CHANGED + "(" + this.viewUserEmail + ")");
      this.$emit(EVENT_ADMIN_VIEW_EMAIL_CHANGED, this.viewUserEmail);
    },
    isSelectedViewUserEmail(email) {
      let result = (email !== undefined && this.viewUserEmail !== undefined && this.viewUserEmail !== null &&
          email.toLowerCase() === ("" + this.viewUserEmail).toLowerCase())
      return result;
    },
    async addAnotherViewUser() {
      await adminService.addCustomer(this.newEmail, "", this.newEmail)
      await this.loadViewUserEmailList();
      this.changeViewUserEmail(this.newEmail);
      this.closeModal('add-modal');
    },
    closeModal(elementId) {
      document.getElementById(elementId).close();
    }
  }
};
</script>

<style>
.label {
  color: white !important;
  font-size: 16px;
}

.admin-div {
  font-weight: bold;
  background-color: #862351;
  border-radius: 10px;
  margin-top: 10px;
  padding-top: 0px !important;
  padding-bottom: 3px !important;
}

.admin-select-text {
  color: white !important;
}
</style>
